import { render, staticRenderFns } from "./BulkProductGridItem.vue?vue&type=template&id=113b0922&scoped=true&"
import script from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./BulkProductGridItem.vue?vue&type=style&index=0&id=113b0922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b0922",
  null
  
)

export default component.exports